import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=cd9644c0&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=cd9644c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9644c0",
  null
  
)

export default component.exports